import { Box, Typography, Image } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import styled from "styled-components"

import { GemContainer } from "./components"

const StoneText = styled(Typography).attrs((props) => ({
  fontWeight: 700,
  pb: "4px",
  px: 2,
  ...props,
}))``
const GemstonesBlock = ({
  gemStones,
  simulatedStone,
  stoneTextStyle,
  showMonth,
}) => {
  return (
    <Box contain pb={4} textAlign="center">
      <GemContainer>
        {gemStones.map((stone) => (
          <Box
            key={`gem-${stone.photo}`}
            mb={{ _: simulatedStone ? 4 : 2, tablet: 4 }}
            width={{ _: "33%", tablet: "16%" }}
          >
            <Image
              alt={stone.alt ? stone.alt : stone.text}
              mb={{ _: 1, tablet: 0 }}
              src={stone.photo}
              width="65px"
            />
            <StoneText {...stoneTextStyle}>{stone.text}</StoneText>
            {showMonth && <Typography pb="4px">{stone.month}</Typography>}
          </Box>
        ))}
      </GemContainer>
    </Box>
  )
}

GemstonesBlock.propTypes = {
  gemStones: PropTypes.array,
  showMonth: PropTypes.bool,
  simulatedStone: PropTypes.bool,
  stoneTextStyle: PropTypes.object,
}
export default GemstonesBlock
